import { useTranslation } from "react-i18next";
import { Button } from "@/components/ui/button";
import { ScrollArea } from "@/components/ui/scroll-area";
import { Spinner } from "@/components/ui/spinner";

/** Shared building blocks for the candidate lists on the left of the targeting workspace. */
export function CandidateWorkspace({ children }: { children: React.ReactNode }) {
  return (
    <ScrollArea className="min-h-0" data-slot="sd-targeting-candidate-scroll">
      {children}
    </ScrollArea>
  );
}

export function CandidateRow({
  label,
  description,
  onAdd,
}: {
  label: string;
  description?: string;
  onAdd: () => void;
}) {
  const { t } = useTranslation("campaignCreation");
  return (
    <div className="flex items-center justify-between gap-3 rounded-md border border-line px-3 py-2">
      <span className="min-w-0">
        <span className="block truncate text-sm font-medium">{label}</span>
        {description ? (
          <span className="block truncate text-xs text-muted-foreground">{description}</span>
        ) : null}
      </span>
      <Button type="button" size="sm" variant="outline" onClick={onAdd}>
        {t("sd.actions.add")}
      </Button>
    </div>
  );
}

export function LoadingRows() {
  return (
    <div className="flex min-h-32 items-center justify-center text-muted-foreground">
      <Spinner />
    </div>
  );
}

export function EmptyCandidates() {
  const { t } = useTranslation("campaignCreation");
  return <p className="py-12 text-center text-sm text-muted-foreground">{t("sd.empty")}</p>;
}

export function TruncatedNotice() {
  const { t } = useTranslation("campaignCreation");
  return <p className="text-xs text-warning-foreground">{t("sd.targeting.truncated")}</p>;
}
